<template>
  <div>
    <v-dialog
      v-model="personModal"
      scrollable
      persistent
      width="500">
      <v-form
        lazy-validation>
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title>{{thispersonName}}</v-card-title>

          <SingleRelative
            :relativeName='personType'
            :modifyIndex='indexTosave'
            :formType='formType'/>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              text
              @click="personModal = false,save()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-card-text>
      <span v-if="personNum > 1">Click on each {{personType}} below to add details.</span>
      <div v-if="dataModel.length !== 0">
        <template v-for="(person,index) in dataModel">
          <template v-if="person.relationship === personType">
            <v-chip
              close
              color="secondary"
              text-color="white"
              v-bind:key="index"
              @click:close="remove(index)"
              @click="personModal = true,setSelected(person)">
              <v-avatar>
                <v-icon>account_circle</v-icon>
              </v-avatar>
              <template v-if="dataModel[index].name === ''">{{dataModel[index].id}}</template>
              <template v-else>{{dataModel[index].name}}</template>
            </v-chip>
          </template>
        </template>
      </div>
      <br>
      <v-btn
        color="primary"
        @click='add'>add</v-btn>
    </v-card-text>
  </div>
</template>

<script>

import { mapFields } from "vuex-map-fields";
import SingleRelative from "./SingleRelative";
import { editFamilyHistory } from '../../../helper/firestore'
export default {
  props: {
    personType: String,
    sibNum: Number,
    formType: Array
  },
  components: {
    SingleRelative
  },
  data: () => ({
    inputMin: 0,
    inputMax: 15,
    indexTosave: null,
    personNum: 1,
    personModal: false,
    selectedperson: {
      id: "",
      dob: "",
      death: "",
      name: "",
      gender: null,
      isLiving: true,
      notes: ""
    },
    fieldRules: [v => !!v || "this field is required"],
    ageRules: [v => (v && v >= 0) || 'Age must be larger or equal to 0'],
    addPersonRule: [v => (v && v >= 0) || "this field is required"]
  }),
  mounted() {
    this.dataModel.forEach((person) => {
      if (person.relationship === this.personType) {
        this.personNum++;
      }
    });
  },
  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
      "snackbar",
      "errorText",
      "genderList",
    ]),
    thispersonName () {
      if (this.selectedperson.name === "") {
        return this.selectedperson.id;
      } else {
        return this.selectedperson.name;
      }
    }
  },
  methods: {
    genID () {
      var ALPHABET =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"

      var ID_LENGTH = 8

      var generate = function () {
        var rtn = ""
        for (var i = 0; i < ID_LENGTH; i++) {
          rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length))
        }
        return rtn
      }
      return generate()
    },
    add() {
      var genderDefault = "Other";
      switch (this.personType) {
        case "maternal grandmother":
        case "maternal aunt":
        case "paternal grandmother":
        case "paternal aunt":
          genderDefault = "Female";
          break;
        case "maternal grandfather":
        case "maternal uncle":
        case "paternal grandfather":
        case "paternal uncle":
          genderDefault = "Male";
          break;
        default:
          break;
      }
      this.dataModel.push({
        relationship: this.personType,
        name: this.personType + this.personNum,
        gender: genderDefault,
        isLiving: true,
        notes: "",
        id: this.personType + this.personNum,
        pid: this.genID(),
        conditions: [],
        dob: '',
        death: '',
        isHalf: false,
        halfSib: '',
        newGender: {
          legal: "",
          identity: "",
          assigned: genderDefault
        },
      });
      this.personNum++;
    },
    remove(index) {
      this.dataModel.splice(index, 1)
      this.dataModel = [...this.dataModel]
      this.personNum--;
    },
    parentsList () {
      let pList
      switch (this.personType) {

        case "paternal cousin":
          pList = this.dataModel.filter(item => {
            return item.relationship === "paternal uncle" || item.relationship === "paternal aunt"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "maternal cousin":
          pList = this.dataModel.filter(item => {
            return item.relationship === "maternal uncle" || item.relationship === "maternal aunt"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "niece/nephew":
          pList = this.dataModel.filter(item => {
            return item.relationship === "sibling"
          }).map(function (obj) {
            return obj.name
          });
          return pList
      }
    },
    save () {
      if (this.indexTosave === -1) {
        this.dataModel.push(this.selectedperson);
      } else {
        this.dataModel[this.indexTosave] = this.selectedperson;
      }
      this.dataModel[this.indexTosave] = this.selectedperson;
      editFamilyHistory(this.dataModel, () => {
      })
    },
    setSelected (person) {
      this.selectedperson = person;
      this.indexTosave = this.dataModel.findIndex(item => {
        return item.id === this.selectedperson.id;
      });
    },
  }
};
</script>
